import getStyles from "./styles";
import CurrentLanguageSelect from "./CurrentLanguageSelect";
import InitialLanguageSelect from "./InitialLanguageSelect";
import type { Language } from "../../types";
import { useAppDispatch, useAppSelector } from "../../redux";
import {
  selectLanguages,
  setCurrentLanguage,
  setIsInitialLanguage,
  selectIsInitialLanguage,
  selectText,
} from "./LanguageSelectSlice";
import { useEffect, useState } from "react";
import type { SelectChangeEvent } from "@mui/material";

export default function _LanguageSelect() {
  window.scroll(0, 0);
  const styles = getStyles();

  const dispatch = useAppDispatch();

  const languages = useAppSelector(selectLanguages);
  const isInitialLanguage = useAppSelector(selectIsInitialLanguage);
  const text = useAppSelector(selectText);

  const [language, setLanguage] = useState<Language>("english");

  useEffect(() => {
    setLanguage(text.language as Language);
  }, [text]);

  const handleInitialLanguageSelect = (language: Language) => {
    dispatch(setCurrentLanguage(language));

    setLanguage(language);

    if (!isInitialLanguage) dispatch(setIsInitialLanguage());
  };

  const handleLanguageChange = (event: SelectChangeEvent<Language>) => {
    const { value } = event.target;

    dispatch(setCurrentLanguage(value as Language));

    setLanguage(value as Language);
  };

  return isInitialLanguage ? (
    <CurrentLanguageSelect
      language={language}
      languages={languages}
      styles={styles}
      handleLanguageChange={handleLanguageChange}
    />
  ) : (
    <InitialLanguageSelect
      languages={languages}
      styles={styles}
      handleInitialLanguageSelect={handleInitialLanguageSelect}
    />
  );
}
